/* eslint-disable */

/**
 * Copyright (c) Grab
 * Grab Design Tokens Project
 * Do not edit directly
 */

export interface TextStyle {
  fontSize: string
  lineHeight: string
  fontWeight: number
  letterSpacing?: string
}

/* font-families */
export const gdsFontFamilyGrabCommunityInline = "Grab Community Inline";
export const gdsFontFamilyGrabCommunitySolid = "Grab Community Solid";
export const gdsFontFamilyInter = "Inter";
export const gdsFontFamilySanomat = "Sanomat Grab App";
export const gdsFontFamilyOvoPrimary = "Convo Sans";
export const gdsFontFamilyPrimary = "Inter";
export const gdsFontFamilySecondaryInline = "Grab Community Inline";
export const gdsFontFamilySecondarySolid = "Grab Community Solid";
export const gdsFontFamilyLegacy = "Sanomat Grab App";

/* text-style */
export const duxtonTextStyleLogotypeInline = {
  fontSize: "32px",
  lineHeight: "40px",
  fontWeight: 720,
} as const satisfies TextStyle;

export const duxtonTextStyleLogotypeSolid = {
  fontSize: "32px",
  lineHeight: "40px",
  fontWeight: 500,
} as const satisfies TextStyle;

export const duxtonTextStyleHeading01Regular = {
  fontSize: "40px",
  lineHeight: "48px",
  fontWeight: 400,
} as const satisfies TextStyle;

export const duxtonTextStyleHeading01Bolder = {
  fontSize: "40px",
  lineHeight: "48px",
  fontWeight: 500,
} as const satisfies TextStyle;

export const duxtonTextStyleHeading02Bolder = {
  fontSize: "32px",
  lineHeight: "40px",
  fontWeight: 500,
} as const satisfies TextStyle;

export const duxtonTextStyleHeading03Bolder = {
  fontSize: "24px",
  lineHeight: "32px",
  fontWeight: 500,
} as const satisfies TextStyle;

export const duxtonTextStyleHeading04Bolder = {
  fontSize: "20px",
  lineHeight: "28px",
  fontWeight: 500,
} as const satisfies TextStyle;

export const duxtonTextStyleHeading05Bolder = {
  fontSize: "18px",
  lineHeight: "26px",
  fontWeight: 500,
} as const satisfies TextStyle;

export const duxtonTextStyleBody01Regular = {
  fontSize: "16px",
  lineHeight: "24px",
  fontWeight: 400,
} as const satisfies TextStyle;

export const duxtonTextStyleBody01Bolder = {
  fontSize: "16px",
  lineHeight: "24px",
  fontWeight: 500,
} as const satisfies TextStyle;

export const duxtonTextStyleBody02Regular = {
  fontSize: "14px",
  lineHeight: "20px",
  fontWeight: 400,
} as const satisfies TextStyle;

export const duxtonTextStyleBody02Bolder = {
  fontSize: "14px",
  lineHeight: "20px",
  fontWeight: 500,
} as const satisfies TextStyle;

export const duxtonTextStyleCallout01Bolder = {
  fontSize: "16px",
  lineHeight: "24px",
  fontWeight: 500,
} as const satisfies TextStyle;

export const duxtonTextStyleCallout02Bolder = {
  fontSize: "14px",
  lineHeight: "20px",
  fontWeight: 500,
} as const satisfies TextStyle;

export const duxtonTextStyleCallout03Bolder = {
  fontSize: "12px",
  lineHeight: "16px",
  fontWeight: 500,
} as const satisfies TextStyle;

export const duxtonTextStyleMetadata01Regular = {
  fontSize: "12px",
  lineHeight: "16px",
  fontWeight: 400,
} as const satisfies TextStyle;

export const duxtonTextStyleMetadata02Regular = {
  fontSize: "10px",
  lineHeight: "12px",
  fontWeight: 400,
} as const satisfies TextStyle;

export const duxtonTextStyleMetadata02Bolder = {
  fontSize: "10px",
  lineHeight: "12px",
  fontWeight: 500,
} as const satisfies TextStyle;
